import { render, staticRenderFns } from "./projectcategories.vue?vue&type=template&id=7d229eee"
import script from "./projectcategories.vue?vue&type=script&lang=js"
export * from "./projectcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports